if (!customElements.get('cart-upsell-recommendations')) {
class CartUpsellRecommendations extends HTMLElement {
    constructor() {
      super();
      // Initialize properties with default values if no values are provided in the dataset
      this.productIds = JSON.parse(this.dataset.productIds) || [];
      this.intent = "related";
      this.limit = this.dataset.limit || 4;
      this.cartUpsellShimmerContainer = this.querySelector('.upsell-products-shimmer-container');
      this.slidecounts();
    }

    slidecounts(){
      if (window.location.pathname.includes('/cart')) {
        this.slides = 5;
        this.mobileSlides = 2.3;
      } else {
        this.slides = 2.3;
        this.mobileSlides = 2.3;
      }
    }

    // When the element is added to the DOM, fetch recommendations for each product ID
    connectedCallback() {
      if (!this.intent) return;
    
      const handleIntersection = async (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
    
        try {
          this.cartUpsellShimmerContainer?.classList.remove('hidden');
    
          const totalLimit = parseInt(this.limit, 10);
          const numProductIds = this.productIds.length;
    
          if (numProductIds === 0 || totalLimit === 0) return;
    
          // Calculate per-product limit (distribute as evenly as possible)
          const basePerProductLimit = Math.floor(totalLimit / numProductIds);
          const extra = totalLimit % numProductIds; // Remaining to distribute
    
          // Construct productId-limit pairs with even distribution
          const productLimits = this.productIds.map((id, index) => {
            return {
              id,
              limit: basePerProductLimit + (index < extra ? 1 : 0) // Distribute remainder to the first N
            };
          });
    
          // Create URLs based on distributed limits
          const urls = productLimits.map(p =>
            `/recommendations/products?product_id=${p.id}&limit=${p.limit}&intent=${this.intent}&section_id=upsell-recommendations`
          );
    
          // Fetch all recommendations
          const responses = await Promise.all(urls.map(url => fetch(url)));
    
          for (let i = 0; i < responses.length; i++) {
            const response = responses[i];
            const limitForThisProduct = productLimits[i].limit;
    
            const text = await response.text();
            const html = document.createElement('div');
            html.innerHTML = text;
    
            const recommendations = html.querySelectorAll('[data-upsell-card]');
            const numToAdd = Math.min(limitForThisProduct, recommendations.length);
    
            const fragment = document.createDocumentFragment();
            for (let j = 0; j < numToAdd; j++) {
              fragment.appendChild(recommendations[j]);
            }
    
            this.querySelector('.swiper-wrapper').appendChild(fragment);
          }
    
          this.cartUpsellShimmerContainer?.classList.add('hidden');
    
          if (this.querySelectorAll('[data-upsell-card]').length) {
            this.querySelector('h3')?.classList.remove('hidden');
    
            new Swiper('.swiper-cart-upsell', {
              slidesPerView: this.mobileSlides,
              spaceBetween: 8,
              navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
              },
              freeMode: true,
              grabCursor: true,
              breakpoints: {
                786: {
                  slidesPerView: this.slides,
                  spaceBetween: 12
                }
              }
            });
          }
        } catch (error) {
          console.error(error);
        }
      };
    
      new IntersectionObserver(handleIntersection.bind(this)).observe(this);
    }
    
  }
  
  customElements.define('cart-upsell-recommendations', CartUpsellRecommendations);
}